import React, { useEffect, useState } from 'react';

import { formatDate } from '../../utils/date'
import { formatWriterName } from '../../utils/util';

import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import { fetchInquiryListData } from '../../services/inquiryService';

import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import BasicTable from '../../components/Table/BasicTable';
import MobileBasicTable from '../../components/Table/MobileBasicTable';

import S from './Support.module.css';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import iconLock from '../../assets/images/support/iconLock.png';
import SearchInput from '../../components/Input/SearchInput';
import { inquiryeHeaderData, inqMobileHeaderData, inquiryOptions } from './SupportData';
import useInput from '../../hooks/useInput';
import Pagination from '../../components/Paging/Pagination';
import { isMobile } from '../../config';

const InquiryPage = () => {
  
  const { pageIdx } = useParams();

  const [iqSearch, setIqSearch] = useInput({ search: '' });
  const [inquiryBodyData, setInquiryBodyData] = useState([]);
  const [pagingInfo, setPagingInfo] = useState([]);
  const [totalCnt, setTotalCnt] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 327);
  }, [location]);
  
  useEffect(() => {
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);
  
  const inquiryListData = async (serachVal, pageIdx) => {
    const response = await fetchInquiryListData(serachVal, pageIdx);
    const iqData = response.iqList;
    setTotalCnt(response.totalCnt);

    const bodyData = iqData.map((item, index) => ({
      num: { text: index+1+((pageIdx-1)*10), className: 'ntIdTableBorder' },
      title: { text: (<>{item.IQ_TITLE} {item.IQ_PWD_YN === 'Y' ? <img src={iconLock}/> : ''}</>), className: 'ntTableTitle' },
      writer: { text: formatWriterName(item.IQ_STAFF_NAME), className: 'ntTableBorder' },
      date: { text: formatDate(item.IQ_INPUT_DATE), className: 'ntTableBorder' },
      status: { text: item.IQ_AS_STATUS === 'Y' ? (<><span className={S.textBlue}>답변완료</span></>) : (<><span className={S.textRed}>답변대기</span></>), className: 'ntTableBorder' },
      idx: item.IQ_IDX,
      url: 'support/inquiry/detail'
    }));
    setInquiryBodyData(bodyData);
    setPagingInfo(response.pageInfo);
  };

  useEffect(() => {
    inquiryListData(iqSearch.search, pageIdx);
  }, [location, pageIdx]);

  const onPageChangeHandler = (pageNumber) => {
    navigate(`/support/inquiry/${pageNumber}`)
  }

  const handleSubmit = (e) => {
    if (e.key === 'Enter') {
      inquiryListData(iqSearch.search, 1);
    }
  }

  return (
    <div>
      <HeaderComponents pageKey="support" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="support" />
        </div>
        <div className='com-content-wrap mt-200'>
          <div style={{minHeight:'650px'}}>
            {isMobile() ? (
              <>
                <div className={S.searchBar}>
                  <SearchInput type='text' options={inquiryOptions} name='search' value={iqSearch.search} onChange={setIqSearch} onKeyPress={handleSubmit} selectclass={'searchSelect'} inputclass={'searchInput'}/>
                </div>
                <div className='mb-10 w-100 jt-con-between al-center' draggable>
                  <a>Total <span className={S.cntFont}>{totalCnt}</span>건</a>
                  <Link to={'/support/inquiry/register'} className={S.blackBtn}>
                    <div>New</div>
                  </Link>
                </div>
                <MobileBasicTable headers={inqMobileHeaderData} items={inquiryBodyData} itemKey="iqMobileTable" />
              </>
            ) : (
              <>
                <div className='mb-35' draggable>
                  <a>Total <span className={S.cntFont}>{totalCnt}</span>건</a>
                </div>
                <BasicTable headers={inquiryeHeaderData} items={inquiryBodyData} itemKey="In_IDX" />
                <div className='flex-row jt-con-between ml-100'>
                  <div className={S.searchBar}>
                    <SearchInput type='text' options={inquiryOptions} name='search' value={iqSearch.search} onChange={setIqSearch} onKeyPress={handleSubmit} selectclass={'searchSelect'} inputclass={'searchInput'}/>
                  </div>
                  <Link to={'/support/inquiry/register'} className={S.blackBtn}>
                    <div >
                      New
                    </div>
                  </Link>
                </div>
              </>
            )}
            <Pagination 
              currentPage={pagingInfo.curPage}
              totalPages={pagingInfo.totalPage}
              onPageChangeHandler={onPageChangeHandler}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InquiryPage;
